import { useEffect, useState, startTransition } from 'react'
import { Transition } from '@headlessui/react'
import { useSearchParams } from 'next/navigation'
import { ErrorBoundary, ErrorFallback } from '@/layout/ErrorBoundary'
import { Footer } from '@/organisms/Footer'
import { SiteNav } from '@/organisms/SiteNav'
import { ReactFCC } from '@/types/react'
import { BaseLayout } from '../BaseLayout'

export const LegalLayout: ReactFCC = ({ children }) => {
  const params = useSearchParams()
  const [showNav, setShowNav] = useState(false)

  useEffect(() => {
    startTransition(() => {
      const hideNav = params.get('hide-nav') === 'true'
      setShowNav(!hideNav)
    })
  }, [params])

  return (
    <BaseLayout isDarkMode={false}>
      <Transition
        show={showNav}
        appear
        className=""
        enter="transition-opacity duration-1000"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition-opacity duration-1000"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <SiteNav />
      </Transition>
      <ErrorBoundary FallbackComponent={ErrorFallback}>{children}</ErrorBoundary>
      <Transition
        show={showNav}
        appear
        className=""
        enter="transition-opacity duration-1000"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition-opacity duration-1000"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <Footer />
      </Transition>
    </BaseLayout>
  )
}
